import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { setUserPresence, removeUserPresence } from '../firebase/firestore';

export const usePresence = (boardId: string | null) => {
  const { user } = useAuth();
  const heartbeatRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!boardId || !user?.id || !user?.email) return;

    // Set initial presence
    const setPresence = async () => {
      await setUserPresence(boardId, user.id, user.email, user.name || user.email);
    };
    setPresence();

    // Set up heartbeat (update presence every 30 seconds)
    heartbeatRef.current = setInterval(async () => {
      await setUserPresence(boardId, user.id, user.email, user.name || user.email);
    }, 30000);

    // Cleanup function
    return () => {
      if (heartbeatRef.current) {
        clearInterval(heartbeatRef.current);
      }
      // Remove presence when component unmounts
      removeUserPresence(boardId, user.id);
    };
  }, [boardId, user?.id, user?.email, user?.name]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (heartbeatRef.current) {
        clearInterval(heartbeatRef.current);
      }
      if (boardId && user?.id) {
        removeUserPresence(boardId, user.id);
      }
    };
  }, [boardId, user?.id]);
};
